// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"187":"search","6008":"editor","7933":"auth","7962":"home"}[chunkId] + "." + {"187":"6a110faa","6008":"ce0d32ec","7933":"980c191d","7962":"8d3eb4fc"}[chunkId] + ".css";
};